"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getL10n = void 0;
const bs_1 = __importDefault(require("./l10n/bam/bs"));
const de_1 = __importDefault(require("./l10n/bam/de"));
const en_1 = __importDefault(require("./l10n/bam/en"));
const es_1 = __importDefault(require("./l10n/bam/es"));
const fr_1 = __importDefault(require("./l10n/bam/fr"));
const sr_1 = __importDefault(require("./l10n/bam/sr"));
const bs_2 = __importDefault(require("./l10n/relic/bs"));
const de_2 = __importDefault(require("./l10n/relic/de"));
const en_2 = __importDefault(require("./l10n/relic/en"));
const es_2 = __importDefault(require("./l10n/relic/es"));
const fr_2 = __importDefault(require("./l10n/relic/fr"));
const sr_2 = __importDefault(require("./l10n/relic/sr"));
const bs_3 = __importDefault(require("./l10n/tickethead/bs"));
const de_3 = __importDefault(require("./l10n/tickethead/de"));
const en_3 = __importDefault(require("./l10n/tickethead/en"));
const es_3 = __importDefault(require("./l10n/tickethead/es"));
const fr_3 = __importDefault(require("./l10n/tickethead/fr"));
const sr_3 = __importDefault(require("./l10n/tickethead/sr"));
const branding_1 = require("./branding");
/**
 * Get l10n definition based on branding
 * @param branding
 * @returns
 */
const getL10n = (branding) => {
    switch (branding) {
        // for branded translations we use the approach to use the bam translations as base, and only overwrite some translations for the branding
        case branding_1.BrandingType.RELIC:
            return {
                bs: Object.assign(Object.assign(Object.assign({}, en_1.default), bs_1.default), bs_2.default),
                de: Object.assign(Object.assign(Object.assign({}, en_1.default), de_1.default), de_2.default),
                en: Object.assign(Object.assign({}, en_1.default), en_2.default),
                es: Object.assign(Object.assign(Object.assign({}, en_1.default), es_1.default), es_2.default),
                fr: Object.assign(Object.assign(Object.assign({}, en_1.default), fr_1.default), fr_2.default),
                sr: Object.assign(Object.assign(Object.assign({}, en_1.default), sr_1.default), sr_2.default),
            };
        // for branded translations we use the approach to use the bam translations as base, and only overwrite some translations for the branding
        case branding_1.BrandingType.TICKETHEAD:
            return {
                bs: Object.assign(Object.assign(Object.assign({}, en_1.default), bs_1.default), bs_3.default),
                de: Object.assign(Object.assign(Object.assign({}, en_1.default), de_1.default), de_3.default),
                en: Object.assign(Object.assign({}, en_1.default), en_3.default),
                es: Object.assign(Object.assign(Object.assign({}, en_1.default), es_1.default), es_3.default),
                fr: Object.assign(Object.assign(Object.assign({}, en_1.default), fr_1.default), fr_3.default),
                sr: Object.assign(Object.assign(Object.assign({}, en_1.default), sr_1.default), sr_3.default),
            };
        // for translations we always use English as base in order to avoid missing labels
        default:
            return {
                bs: bs_1.default,
                de: de_1.default,
                en: en_1.default,
                es: es_1.default,
                fr: fr_1.default,
                sr: sr_1.default
            };
    }
};
exports.getL10n = getL10n;
//# sourceMappingURL=l10n.js.map